import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";



// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import {People,Widgets, Build } from "@material-ui/icons";



import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";

import SectionCarousel from "./SectionCarousel.jsx";



class SectionService extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
       <h2 className={classes.title}> Port Operation and Engineering Services</h2>
        <SectionCarousel/>
          <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h4 className={classes.description}>
             MGEC provide Port Cranes Technology Development, Port Engineering & Automation System, Terminal Operations System, Managing, Supervision of Port Equipment & Operations, Lease, Upgrading, Modification, Modernization & Mobilization of Port Equipment, Deep Sea Port & Dry Port Construction, Optimization of Port Crane Maintenance System & Operations.
             </h4>
          </GridItem>
        </GridContainer>
        </div>

<br />
<br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Port Consultancy"
              description="We offer port consultancy services with inspection and survey works related with New Port / Used Port/ Gateway and Transhipment."
              icon={Widgets}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Port Engineering"
              description="We offfer and focus mainly on port engineering services in which engineering consultancy, maintenance of port equipment and automation."
              icon={Build}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Port Operation & Management"
              description="We offer the turnkey solution for port and terminal operation with effective and latest port management system."
              icon={People}
              iconColor="danger"
              vertical
            />
          </GridItem>
        </GridContainer>
   
         <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <h3 className={classes.title}>
          Port Technology Consultancy            </h3>
            <h5 className={classes.desc}>
            We offer Feasibility Study, Green Field / Brown Field Study, 
            Dry / Deep Sea Port Survey & Inspection, Gateway or Transhipment Traffic Study,
            Facilities and Capacities Analysis, New Port Location & Geography Analysis,
             Deep Sea Port and Dry Port Construction, CAPEX & OPEX approaches for new Container Port,
          Inspections & Survey related with new Port / existing Port conditions.
            </h5>

          </GridItem>
        </GridContainer>
        <br />
        <GridContainer justify="center">
         <GridItem xs={12} sm={12} md={4}>
          <h3 className={classes.title}>
            Port Operation & Management
            </h3>
            <h5 className={classes.desc}>
              We offer Deep-Drive with SOPS(Standard Operation Procedure), Operating Terminal & Ports at Deep Sea, Dry Port and Inland Port, Operating Gateway and Transhipment Service, Optimize Terminal Operations System, Operating & Utilization of Port Equipment, Operational Issues Analysis, Yard Planning & Container Handling, Quary & Berth Arrangement, Ship Stowage & Sequencing and Port Management.
            </h5>
          </GridItem>
        </GridContainer>
        <br />

        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
          
            <h3 className={classes.title}>Port Engineering</h3>
            <h5 className={classes.desc}>
            We offfer Port Cranes Technology Development Supervision, Port Engineering and Automation System Supervision, Upgrading, Modification, Modernization, Mobiliztion and Relocation of Port Equipment, Provision and Supervision of Port Equipment Maintenance Services, Optimization of Port Crane Maintenance System and Operations, Provision of effective Management & Supervision on all kinds of Port Engineering and Operation Services, Selection of Port Equipment(Quay & Yard Cranes) for Terminal Operations, Total Life Cycle Costing Evalution (Total Cost of Ownership) Analysis for Port Equipment, CAPEX and OPEX Approaches for new Equipment Procurement, Inspection and Survey on Port Equipment for determining of equipment reliability, economic life span and OEM design defection, Provision on Port IT Technology and Inventory Management and Spare Parts Supply.
            </h5>

          </GridItem>
        </GridContainer>
 <br />
 
  </div>

    );
  }
}

export default withStyles(workStyle)(SectionService);



// WEBPACK FOOTER //
// ./src/views/PortPage/Sections/SectionPhoto.jsx